/* eslint-disable import/prefer-default-export */
export const activationCodeRegex = (val: string): string =>
  val.replace(/[^a-zA-Z\d]/g, '')
